module.exports = ".align-buttons {\n  text-align: right; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/master/master-battery/master-battery.component.scss
// module id = ./src/app/master/master-battery/master-battery.component.scss
// module chunks = main